/**
 * Reference resolution for catalog parts.
 *
 * When all fields of a part have a selected value, finds the unique
 * catalog item matching all selections.
 *
 * Pure function — no React or service dependencies.
 */

import type { FieldSelections } from './assembly-types';
import type { ICatalogPart } from './types';

/**
 * Resolve the product reference for a part given field selections.
 *
 * @returns The unique ref string if exactly one item matches, null otherwise
 *          (either incomplete selections or ambiguous match).
 */
export function resolveReference(part: ICatalogPart, selections: FieldSelections): string | null {
    // All fields must have a selection
    const hasAllFields = part.fields.every((field) => selections[field.column] != null);
    if (!hasAllFields) return null;

    const matches = part.items.filter((item) =>
        part.fields.every((field) => item[field.column] === selections[field.column])
    );

    return matches.length === 1 ? matches[0].ref : null;
}
